export default {
  'app.org.title': 'องค์กร',
  'app.org.column.id': 'รหัสองค์กร',
  'app.org.column.name': 'ชื่อองค์กร',
  'app.org.column.timezone': 'เขตเวลา',
  'app.org.column.website': 'เว็บไซต์องค์กร',
  'app.org.column.isCreator': 'ผู้สร้าง',
  'app.org.column.createTime': 'เวลาสร้าง',
  'app.org.column.operate': 'ดำเนินการ',
  'app.org.column.operate.enter': 'เข้า',
  'app.org.column.operate.edit': 'แก้ไข',
  'app.org.column.operate.delete': 'ลบ',
  'app.org.column.operate.placeholder': 'กรุณากรอกชื่อ/รหัสองค์กร',
  'app.org.create': 'สร้างองค์กร',
  'app.org.create.submit': 'สร้างองค์กร',
  'app.org.bind.tip': 'สร้างองค์กร',
  'app.org.create.tip': 'เคยสร้างองค์กรแล้วหรือไม่',
  'app.org.create.tip.bind': 'เพื่อผูกองค์กร',
  'app.org.success.tip': 'กลับไปยังคอนโซล',
  'app.org.bind': 'ผูกองค์กร',
  'app.org.bind.submit': 'เสร็จสิ้นการผูก',
  'app.org.create.create': 'สร้าง',
  'app.org.create.cancel': 'ยกเลิก',
  'app.org.create.save': 'บันทึก',
  'app.org.create.profile': 'โปรไฟล์องค์กร',
  'app.org.create.name.placeholder': 'ป้อนชื่อองค์กร',
  'app.org.create.website.placeholder': 'ป้อน URL (โดเมนระดับสูง)',
  'app.org.create.timezone': 'เขตเวลา',
  'app.org.create.timezone.tip': '(เลือกแล้วไม่สามารถเปลี่ยนแปลงได้)',
  'app.org.create.currency': 'สกุลเงิน',
  'app.org.create.usd': 'USD',
  'app.org.create.success': 'สร้างสำเร็จ',
  'app.org.edit.success': 'แก้ไขสำเร็จ',
  'app.org.rule.blank': 'ไม่สามารถเว้นว่างช่องนี้ได้',
  'app.org.rule.char': 'ไม่อนุญาตตัวอักษรที่ไม่ถูกต้องในชื่อตัวละคร',
  'app.org.rule.name.exists': 'ชื่อองค์กรนี้มีอยู่แล้ว',
  'app.org.rule.url.exists': 'URL นี้มีอยู่แล้ว',
  'app.org.rule.url.start': 'โปรดป้อน URL ที่เริ่มต้นด้วย www',
  'app.org.delete.title': 'ลบองค์กร',
  'app.org.delete.content':
    'คำเตือน! การลบองค์กรของคุณไม่สามารถย้อนกลับได้ จะลบข้อมูลและข้อมูลต่างๆ เช่นผู้ใช้งาน ธุรกิจ ยอดคงเหลือ บิล คำสั่งซื้อและดอกเบี้ยขององค์กรนี้อย่างถาวรและบริการที่เกี่ยวข้องทั้งหมดจะถูกยกเลิก',
  'app.org.delete.warn': 'เมื่อมีการชำระเงินเพิ่มเติม บัญชีของคุณไม่สามารถลบได้!',
  'app.org.delete.cancel': 'ยกเลิก',
  'app.org.delete.next': 'ต่อไป',
  'app.org.delete.delete': 'ลบ',
  'app.org.delete.confirm': 'ยืนยันการลบ',
  'app.org.delete.confirm.content':
    'ก่อนที่บัญชีของคุณจะถูกลบออก เราจะทำการยืนยันบัญชีของคุณดังนี้ โปรดค้นหารหัสยืนยันในอีเมลของคุณ',
  'app.org.delete.confirm.send': 'ส่งรหัสยืนยัน',
  'app.org.delete.confirm.send.resend': 'ส่งรหัสยืนยันอีกครั้ง',
  'app.org.delete.confirm.resend': 'ส่งอีกครั้ง',
  'app.org.delete.confirm.rule': 'โปรดป้อนรหัสยืนยันที่ถูกต้อง',
  'app.org.delete.success': 'ลบสำเร็จ',
  'app.org.delete.balance': 'هذه المنظمة لديها رصيد ولا يمكن حذفها.',
};
